import { Box, styled, Typography } from '@mui/material';

export const CredentialContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}));

export const CredentialSummary = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMediumBold,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.secondary,
}));
